import CheckoutStepsConfig from '@/v-shop/checkout/common/checkout-steps-config'
CheckoutStepsConfig.recetadigital = function () {
	return {
		title: 'Confirma la consumición de tus Recetas Digitales',
		editable: true,
	}
}

